"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AnnouncementItem = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@icis/ui-kit");
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _Item = require("./Item.style");
var _l10n = require("../../../l10n");
var _checkAnnouncementType = require("../../../utils/checkAnnouncementType");
var _date = require("../../../utils/date");
var _withLocale = _interopRequireDefault(require("../../HOCs/withLocale"));
const AnnouncementItem = props => {
  const translate = (0, _l10n.getMessages)(props.locale);
  const date = (0, _date.getDateStringFromTimestamp)({
    timestamp: props.date,
    time: true,
    locale: props.locale
  });
  const publicationName = props.publicationName ? " ".concat(props.publicationName) : '';
  const header = "".concat(date).concat(publicationName);
  const isCorrection = props.typeId === _checkAnnouncementType.announcementTypes.correction;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Item.AnnouncementTypeWrapper, {
    isCorrection: isCorrection,
    "data-test-id": "announcement-type-wrapper"
  }, /*#__PURE__*/React.createElement(_uiKit.Text.H6, null, translate(_checkAnnouncementType.announcementTypeIdToIntlText[props.typeId] || _checkAnnouncementType.defaultIntlText))), /*#__PURE__*/React.createElement(_Item.HeaderWrapper, null, /*#__PURE__*/React.createElement(_uiKit.Text.Body, {
    variant: "BoldBlack"
  }, header)), /*#__PURE__*/React.createElement(_Item.AnnouncementBody, null, /*#__PURE__*/React.createElement(_uiKit.Text.Body, {
    dangerouslySetInnerHTML: {
      __html: props.body
    }
  })));
};
exports.AnnouncementItem = AnnouncementItem;
var _default = exports.default = (0, _flowRight.default)(_withLocale.default)(AnnouncementItem);